/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import useDevice from "hooks/useDevice";
import React from "react";
import { useUI } from "state";

interface UseDetectClickOutsideInterface {
  (ref: React.RefObject<HTMLElement>, callback: () => void): void;
}

export const useDetectClickOutside: UseDetectClickOutsideInterface = (
  ref,
  callback
) => {
  const { isModalOpen, isNestedModalOpen } = useUI();
  const { isDesktop } = useDevice();
  const handleClick = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };
  React.useEffect(() => {
    if (isModalOpen || isNestedModalOpen) {
      // Precedence is important. nested modal should be closed first
      if (isNestedModalOpen) {
        document
          .getElementById("nested-portal")
          ?.addEventListener("click", handleClick);
      } else if (isModalOpen) {
        document
          .getElementById("portal")
          ?.addEventListener("click", handleClick);
      }
    } else {
      document.addEventListener("click", handleClick);
    }
    // for tablets, phones, etc.
    if (!isDesktop) document.addEventListener("touchmove", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
      if (!isDesktop) document.removeEventListener("touchmove", handleClick);
    };
  });
};
